// La respuesta de error de una Edge Function no siempre llega parseada en
// `error` (depende de la versión del SDK): el body JSON real queda accesible
// en `error.context`, que es el Response original del fetch.
export async function extractFunctionErrorMessage(fnError) {
  try {
    if (fnError?.context && typeof fnError.context.json === 'function') {
      const body = await fnError.context.json();
      if (body?.error) return body.error;
    }
  } catch {
    // Ignorar: se usa el mensaje genérico de fallback.
  }
  return null;
}
